import React from 'react';

import { useDisclosure } from '@chakra-ui/react';

import { AccountIcon } from 'components/Icons';
import { BlueprintDetailCard } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/Cards/BlueprintDetailCard';
import { ManagedAccounts } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/ManagedAccounts';

export const Accounts: React.FC = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  return (
    <>
      <BlueprintDetailCard
        icon={<AccountIcon />}
        label="Accounts"
        onClick={() => onOpen()}
      />
      {isOpen && <ManagedAccounts isOpen={isOpen} onClose={onClose} />}
    </>
  );
};
